import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { Button } from "src/components/Button/Button.tsx";
import { ModalV3 } from "src/components/ModalV3/ModalV3.tsx";
import { H4 } from "src/components/Heading/Heading.tsx";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";

await loadTranslations(TranslationNamespaceEnum.DeleteRecordConfirmationModal);

export const DeleteRecordConfirmation = (props: {
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
}) => {
  const { onCancel, onConfirm, onClose } = props;
  const { t } = useTranslation(
    TranslationNamespaceEnum.DeleteRecordConfirmationModal,
  );
  return (
    <ModalV3 onClose={onClose}>
      <ModalV3.Positioner>
        <ModalV3.Content>
          <ModalV3.CloseTrigger />
          <ModalV3.Header>
            <ModalV3.Title>&nbsp;</ModalV3.Title>
          </ModalV3.Header>

          <ModalV3.Body
            style={{
              textAlign: "center",
              width: 460,
            }}
          >
            <H4>{t("title")}</H4>
          </ModalV3.Body>

          <ModalV3.Footer>
            <ModalV3.FooterButtons>
              <Button
                skin={"neutral"}
                textAlign={"center"}
                variant={"outlined"}
                onClick={onCancel}
              >
                {t("actions.cancel", {
                  ns: TranslationNamespaceEnum.Common,
                })}
              </Button>
              <Button
                startAdornment={<span className={"icon-15-trash"} />}
                skin={"danger"}
                textAlign={"center"}
                variant={"filled"}
                onClick={onConfirm}
              >
                {t("actions.delete", {
                  ns: TranslationNamespaceEnum.Common,
                })}
              </Button>
            </ModalV3.FooterButtons>
          </ModalV3.Footer>
        </ModalV3.Content>
      </ModalV3.Positioner>
    </ModalV3>
  );
};
